const initialState = { isLoading: false, brands: [], requestMake: false };
export const FETCH_CARD_BRANDS = 'FETCH_CARD_BRANDS';
export const FETCH_CARD_BRANDS_SUCCESS = `${FETCH_CARD_BRANDS}_SUCCESS`;
export const FETCH_CARD_BRANDS_FAIL = `${FETCH_CARD_BRANDS}_FAIL`;

const CardBrandsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_CARD_BRANDS:
      return { ...state, isLoading: true, requestMake: true };
    case FETCH_CARD_BRANDS_SUCCESS:
      return { ...state, isLoading: false, brands: action.payload.data };
    case FETCH_CARD_BRANDS_FAIL:
      return { ...state, isLoading: false, error: action.error };
    default:
      return { ...state };
  }
};

export default CardBrandsReducer;
